export const JOB_APPLICATION_SUBMIT_REQUEST = 'job/application-submit-request'
export const JOB_APPLICATION_SUBMIT_SUCCESS = 'job/application-submit-success'
export const JOB_APPLICATION_SUBMIT_FAILED = 'job/application-submit-failed'
